var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"feed-header"},[_c('el-col',{staticClass:"feed-header__info"},[_vm._v("\n    "+_vm._s(_vm.userName)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }